import React from 'react';
import ColumnSelectionArea from './step3/ColumnSelectionArea';
// import { useDispatch } from 'react-redux';
// import { getExtCustomColumns } from '../../store/extCustomColumns/actions';

const Step3 = () => {
    // const dispatch = useDispatch();
    // useEffect(() => {
    //     dispatch(getExtCustomColumns());
    // }, [dispatch]);
    
    return (
        <>
            <ColumnSelectionArea />
        </>
    );
};

export default Step3;
